// pages/BlogsPage.jsx
import React, { useEffect, useState, useCallback } from 'react';
import BlogCard from '../components/blog/BlogCard';
import ApiService from '../api/ApiService';
import PageHeader from "../components/common/PageHeader";
import MetaData from "../helpers/MetaData";
import GoToTop from "../helpers/GoToTop";

const BlogsPage = () => {
    const [blogs, setBlogs] = useState([]);
    const [top, setTop] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const res = await ApiService.fetchBlogs();
                setBlogs(res);
            } catch (error) {
                console.error("Error fetching blogs:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);

    const festRef = useCallback((node) => {
        if (node) {
            setTop(node.offsetTop - 95);
        }
    }, []);

    const skeletons = Array.from({ length: 3 }, (_, i) => (
        <div className="p-3" key={i}>
            <div className="shadow rounded-3 overflow-hidden bg-light" style={{ height: 400 }} />
        </div>
    ));

    return (
        <>
            <MetaData title="Blogs - ISKCON of Attapur" />
            <PageHeader title="Latest Blogs" imgSrc="/images/page-header/13.webp" />
            <section className="py-5" ref={festRef}>
                <div className="container">
                    <div className="heading mb-5">
                        <h2 className="head-1 text-uppercase">OUR LATEST BLOGS</h2>
                    </div>
                    <div className="row">
                        {loading ? (
                            <div className="d-flex justify-content-between w-100">{skeletons}</div>
                        ) : (<>
                            {blogs.map((blog) => (
                                <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                                    <BlogCard key={blog._id} blog={blog} />
                                </div>
                            ))}
                        </>
                        )}
                    </div>
                </div>
            </section>
            <GoToTop top={top} />
        </>
    );
};

export default BlogsPage;
